const settings = {
  appName: process.env.VUE_APP_NAME,
  endPoint: process.env.VUE_APP_ENPOINT_BACKEND,
  endPointApp: process.env.VUE_APP_ENPOINT_APP,
};

export default settings;
